import React, {useState} from 'react';

function ProgressCounter({value}) {
    return (
        <div style={{color:'#00ca97', fontWeight:'bold'}}>{value}</div>
    )
}

export default ProgressCounter